<nz-select nzShowSearch (nzOpenChange)="getOptions()" nzAllowClear nzPlaceHolder="Select a {{parameter.Label}}"
   [(ngModel)]="dashboardParams[parameter.Name]" (ngModelChange)="valueChanged($event);">
  <ng-container *ngFor="let option of options">
    <nz-option *ngIf="!isLoading" [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
  </ng-container>
  <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
    <i nz-icon nzType="loading" class="loading-icon"></i> {{'Loading ...'| locale}}
  </nz-option>
</nz-select>
